import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import { BUTTON_COLOR, BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,

    // hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '42px',
    subHeading: '38px',
    body: '16px',
    body_lv2: '12px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 700,
    body: 400,
    body_lv2: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
      },
    },
  },
  colors: {
    bgAlternative: BG_COLOR.alternative,
    bgFooter: BG_COLOR.footer,
    bgPrimary: BG_COLOR.primary,
    bgSecondary: BG_COLOR.secondary,
    btnMainColor: BUTTON_COLOR.primary,
    mainColor: BG_COLOR.primary,
    mainColorText: TEXT_COLOR.primary,
    mainColorText2: TEXT_COLOR.primary2,
    secondaryColorText: TEXT_COLOR.secondary,
    transparent: 'transparent',
    theme: {
      bgPrimary: BG_COLOR.primary,
      bgSecondary: BG_COLOR.secondary,
    },
  },
};

export default extendTheme(theme);
